<template>
  <div>
    <el-carousel :interval="6000" :height="bannerHeight">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img
          ref="banner"
          style="margin-top: 0; cursor: pointer;width: 100%;"
          :src="item.imgUrl"
          @click="onBannerClick(item)"
          @load="loadImage"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getBannerListApi } from '@/api/system'
import { bannerAliasDict } from '@/dictionary'

export default {
  name: 'LoginBannerList',

  data() {
    return {
      transitionName: 'fade-transform',
      bannerList: [],
      bannerWidth: '',
      bannerHeight: '6.8rem'
    }
  },

  created() {
    this.getSwiperBannerList()
  },

  methods: {
    /**
     * 获取登录中心首页轮播图
     */
    getSwiperBannerList() {
      getBannerListApi({ alias: bannerAliasDict.PASSPORT_BANNER.value })
        .then(res => {
          this.bannerList = (res.data || []).map(item => {
            return {
              itemId: item.itemId,
              bannerId: item.bannerId,
              ...(item.itemInfo || {}),
              ...(item.imgInfo || {}),
              ...(item.timeInfo || {}),
              ...(item.bannerInfo || {})
            }
          })
          if (this.bannerList.length === 0) {
            this.bannerList = [
              { imgUrl: require('@/assets/images/common/banner.png') }
            ]
          }
        })
        .catch(err => {
          this.bannerList = [{ imgUrl: require('@/assets/images/common/banner.png') }]
          if (err?.message) this.$message.error(err.message)
        })
    },
    /**
     * 点击轮播图
     */
    onBannerClick(banner) {
      if (banner?.targetAddr) {
        window.location.href = banner.targetAddr
      }
    },
    /**
     * 图片加载完成
     */
    loadImage() {
      // this.bannerHeight = this.$refs.banner[0].height + 'px'
      // this.bannerWidth = this.$refs.banner[0].width + 'px'
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-carousel__indicator--horizontal .el-carousel__button,
::v-deep
  .el-carousel__indicator--horizontal.is-active
  .el-carousel__button {
  width: 6px;
  height: 6px;
  background: $white-color;
  border-radius: 50%;
  opacity: 0.5;
}

::v-deep
  .el-carousel__indicator--horizontal.is-active
  .el-carousel__button {
  opacity: 1;
}
</style>
